export const RateEstimateStatus = {
  PENDING: "RateEstimatePending",
  SUCCESSFUL: "RateEstimateSuccessful",
  REDUCED: "RateEstimateReduced",
  DECLINED: "RateEstimateDeclined",
  NO_RECORD: "RateEstimateNoRecord",
  EXPIRED: "RateEstimateExpired",
  INVALID: "RateEstimateInvalid",
  EQUIFAX_ERROR: "RateEstimateEquifaxError",
  ERROR: "RateEstimateError",
  ACCOUNT_SUSPENDED: "RateEstimateAccountSuspended",
  APPLICATION_SUBMITTED: "ApplicationSubmitted",
};

export const errorStatusResponses = [
  RateEstimateStatus.INVALID,
  RateEstimateStatus.EQUIFAX_ERROR,
  RateEstimateStatus.ERROR,
  RateEstimateStatus.ACCOUNT_SUSPENDED,
];

export const successStatusResponses = [
  RateEstimateStatus.SUCCESSFUL,
  RateEstimateStatus.REDUCED,
];
